import { ProjectSubtype } from "fond/types";

// NBN Cost to Serve s18 package file names
const fileNames = [
  "activity_code",
  "aoi",
  "awr",
  "blocker",
  "boundary",
  "cable",
  "cable_assignment",
  "cadastre",
  "duct",
  "duct_route",
  "equipment",
  "equipment_hfc",
  "equipment_port",
  "equipment_port_frequency",
  "equipment_power",
  "metadata",
  "planning_brief",
  "range",
  "route",
  "site",
  "sjr",
  "sl",
  "sl_to_copperpair",
  "sl_to_ne",
  "splitter_to_enclosure",
  "structurepoint",
];

/**
 * Converts a file name to a layer ID based on the project subtype.
 * @param key The file name to convert.
 * @param type The project subtype (either "nbn_cost_to_serve" or "nbn_idd_lite").
 * @returns The layer ID corresponding to the file name and project subtype.
 */
export const fileNameToLayerId = (key: string, type: ProjectSubtype): string => {
  const prefix = type === "nbn_cost_to_serve" ? "input_layers/cabling/" : "input_layers/base_data/";
  return `${prefix}${key}`;
};

/**
 * Generates an array of file objects for the NBN project based on the project subtype.
 * @param type The project subtype (either "nbn_cost_to_serve" or "nbn_idd_lite").
 * @returns An array of objects containing the title, file name, and key for each file.
 */
export const getNBNFiles = (type: ProjectSubtype): Array<{ title: string; file: string; key: string }> =>
  fileNames
    // For Cost to serve, we don't want to show the awr file
    .filter((name) => !(type === "nbn_cost_to_serve" && name === "awr"))
    .flatMap((fileName) =>
      ["DAT", "ID", "MAP", "TAB"].map((ext) => ({ title: fileName, file: `${fileName}.${ext}`, key: fileNameToLayerId(fileName, type) }))
    );
